import './google_login_link_component.scss'
